import { PIE_DEFAULT_PROPS } from '../ChartPie'

export const CHART_DONUT_PIE_PROPS = {
  ...PIE_DEFAULT_PROPS,
  innerRadius: '64%',
  isAnimationActive: false,
  outerRadius: '96%',
}
